export default __webpack_public_path__ + "static/media/avatar.01496601.jpg";